import { FC, useEffect, useState } from 'react';
import { CustomOption, CustomOptionWrapper, SelectingItemMainWrapper, SettingPanelMultiSelectItem } from '../../styles';
import { VideoJsPlayer } from 'video.js';
import { PlayBackRateProps, PlaySpeed, settingControllerKey } from '../../PlayerModels';
import { Box } from '../../../../styles';
import { IconSpeedRate } from '../../../../icons';
import { PanelSettingHeader, PanelSettingLayer } from '../../styles/Panel';

export const PlaybackRateSelector: FC<{
  player: VideoJsPlayer,
  handleSettingItemClick: (controllerKey: settingControllerKey) => void,
  activeSetting: string | null
}> = ({ player, handleSettingItemClick, activeSetting }) => {
  const [selectedRate, setSelectedRate] = useState<string>('1');
  const [isOpen, setIsOpen] = useState(false);
  const [isAtLiveEdge, setIsAtLiveEdge] = useState(false);
  const rates = [
    { label: '0/5', value: '0.5' },
    { label: '0/75', value: '0.75' },
    { label: '1' + ' (عادی)', value: '1' },
    { label: '1/25', value: '1.25' },
    { label: '1/5', value: '1.5' },
    { label: '2', value: '2' },
  ];

  useEffect(() => {
    // Mirror the live badge / progress bar: read the player's live-edge state,
    // which stays correct while paused (`timeupdate` stops firing when paused).
    const handleLiveState = () => {
      setIsAtLiveEdge(Boolean(player.liveTracker?.atLiveEdge()));
    };
    handleLiveState();
    player.on('timeupdate', handleLiveState);
    player.on('pause', handleLiveState);
    player.on('play', handleLiveState);
    player.on('seeked', handleLiveState);
    return () => {
      player.off('timeupdate', handleLiveState);
      player.off('pause', handleLiveState);
      player.off('play', handleLiveState);
      player.off('seeked', handleLiveState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isAtLiveEdge && Number(selectedRate) !== 1)
      changePlaybackRate('1');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAtLiveEdge]);

  const changePlaybackRate = (rate: string) => {
    setSelectedRate(rate);
    if (player) {
      player.playbackRate(rate);
      setIsOpen(false);
    }
  };
  const toggleMenu = (e, key) => {
    e.stopPropagation();
    if (isAtLiveEdge) return;
    handleSettingItemClick(key);
    setIsOpen(!isOpen);
  };

  return <>
    {!activeSetting &&
      <SettingPanelMultiSelectItem isAtLiveEdge={isAtLiveEdge} icon={<IconSpeedRate />} label="player.speed_rate" onClick={(e) => toggleMenu(e, 'speed')}
        value={selectedRate === '1' ? '1' + ' (عادی)' : String(selectedRate).replace('.', '/')} />}
    {activeSetting === 'speed' && <PanelSettingLayer>
      <RateSelect value={selectedRate || ''} options={rates} onChange={changePlaybackRate} returnAction={(e) => toggleMenu(e, null)} />
    </PanelSettingLayer>}
  </>;
};

export default PlaybackRateSelector;

const RateSelect = ({ value, options, onChange, returnAction }: PlayBackRateProps) => {
  return (
    <Box>
      <PanelSettingHeader label={'player.speed_rate'} handleClick={(e) => returnAction(e)} />
      <SelectingItemMainWrapper>
        {options.map((item: PlaySpeed) => (
          <CustomOptionWrapper key={item.value} onClick={(e: any) => {
            onChange(String(item.value));
            returnAction(e);
          }}>
            <CustomOption selected={String(item.value) === value}>
              {item.label}
            </CustomOption>
          </CustomOptionWrapper>
        ))}
      </SelectingItemMainWrapper>
    </Box>
  );
};
